import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import ClusterChart from '../../Chart/ClusterChart';
import {authContext} from '../../Context/Authentication/authContext';
import {dataScienceURL} from '../../config';
import {generateBarChartData, PROPERTY_TYPE_LABELS} from '../../Helpers/helpers'


const PropertyType = (props:any) => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [chartLabel, setChartLabel]: any = useState(PROPERTY_TYPE_LABELS);
  const {type} = props


  useEffect(() => {
    getPropertyTypes(type);
  }, [state.filters.zipcodePrediction,state.filters.county,state.filters.msa]);



  const getAPIEndpoint = (type:any) => {
    if (type === 'city') {
      return `${dataScienceURL}getPropertyTypeByCity?state=${state.filters.state}&city=${state.filters.city[0]}`
    } else if (type === 'zipcode') {
      let zip = state.filters.zipcodePrediction.length > 0 ? state.filters.zipcodePrediction[0] : state.filters.zipcodePrediction
      zip = zip.split('_')
      return `${dataScienceURL}getPropertyTypeByZip?state=${state.filters.state}&zipcode=${zip[0]}`
    } else if (type === 'metroarea') {
      let msa = state.filters.msa.length > 0 ? state.filters.msa[0] : state.filters.msa
      return `${dataScienceURL}getPropertyTypeByMetro?state=${state.filters.state}&metroarea=${msa.name}`
    }
    else if (type === 'county') {
      let county = state.filters.county.length > 0 ? state.filters.county[0] : state.filters.county
      return `${dataScienceURL}getPropertyTypeByCounty?state=${state.filters.state}&county=${county}`
    }
  }

  const getPropertyTypes = async (type:any) => {
    try {
      const response = await axios.get(getAPIEndpoint(type) as any);
      const resp = response.data?.list
      console.log(resp)
      const data = generateBarChartData(resp);
      setChartData(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className='population-main'>
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        <>
          <div className='population-main__text'>Property Distribution</div>
          <ClusterChart
            chartData={chartData}
            info={chartLabel}
          />
        </>
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default React.memo(PropertyType);
